import Cookies from 'js-cookie'
import Redirect from './redirect'

export default class Jwt {
  static COGNITO_ID_TOKEN = 'cognito-id-token'

  static getIdToken() {
    const token = Cookies.get(this.COGNITO_ID_TOKEN)
    if (!token) {
      Redirect.navigate()
    }
    return token
  }
}
